import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { ProductVisual } from './ProductVisual';
import { CHECKOUT_URL } from '../data/product';
const included = ['6 volumes · 300 landscape pages', '60+ ready-to-run class plans', 'Silks, hoop & trapeze · every skill at 3 levels', '25 printable worksheets', '5 bonuses, incl. The Flight Plan', 'Lifetime access to your files'];
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="w-full bg-cloud text-ink" data-id="element-200" data-mp="1rt86u0b6eh4r">
      <div className="max-w-2xl mx-auto px-5 py-16 sm:py-20" data-id="element-201" data-mp="25shn0zzdtb8q">
        <div className="text-center" data-id="element-202" data-mp="25pv5c7is1fcs">
          <p className="text-[11px] font-semibold uppercase tracking-[1.6px] text-coral-deep" data-id="element-203" data-mp="20sv88m3wnmxt">Complete package</p>
          <h2 id="pricing-heading" className="mt-3 font-display text-3xl font-extrabold text-ink sm:text-5xl" data-id="element-204" data-mp="3h6bkdzqf5tz4">
            Your whole year of aerial classes, planned
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl border border-cloud-dark bg-white shadow-soft" data-id="element-205" data-mp="3vyf6oqmway1b">
          <div className="bg-ink px-5 py-5 text-center" data-id="element-206" data-mp="4ruhzdkbc27g">
            <h3 className="font-display text-lg font-bold tracking-tight text-white sm:text-2xl" data-id="element-207" data-mp="9si7fusw8azk">Aerial Class Ready — Complete Package</h3>
            <p className="mt-1 text-[13px] font-semibold uppercase tracking-widest text-amber" data-id="element-208" data-mp="eq0jvv64d8cb">6 Volumes + 5 Bonuses</p>
          </div>
          <div className="apparatus-strip h-1.5 w-full" aria-hidden="true" data-id="element-209" data-mp="3d6urqrfoqo6d" />

          <div className="p-5 sm:p-7" data-id="element-210" data-mp="3i8k01zbiwnqr">
            <div id="offer" className="scroll-mt-4 rounded-2xl" data-id="element-211" data-mp="3n754yc1pzvlj">
              <ProductVisual lazy className="w-full" data-id="element-212" data-mp="3n5u1yeg3mrvh" />
            </div>

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-213" data-mp="3rywtkh1bfr91">
              {included.map(item => <li key={item} className="flex items-start gap-2 text-sm text-ink" data-id="element-214" data-mp="2uhogfph80yul">
                  <span className="mt-0.5 flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full bg-teal" data-id="element-215" data-mp="2zgivcgc2i39f">
                    <CheckIcon className="h-3 w-3 text-white" aria-hidden="true" data-id="element-216" data-mp="2rfa2zhrwi1cp" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 border-t border-cloud-dark pt-6 text-center" data-id="element-217" data-mp="315cxxnil1pdo">
              <p className="text-[13px] text-slate" data-id="element-218" data-mp="2w7bf93p2js2q">
                Total value <span className="line-through" data-id="element-219" data-mp="28i0ma8dyn1z5">$97 USD</span>
              </p>
              <div className="mt-1 flex items-start justify-center gap-1 text-ink" data-id="element-220" data-mp="28k38sifwmcz4">
                <span className="mt-2.5 font-display text-3xl font-bold" data-id="element-221" data-mp="23kgx4dfq54sf">$</span>
                <span className="font-display text-[56px] font-bold leading-[0.9] sm:text-7xl" data-id="element-222" data-mp="2ih80sywfl2nu">27</span>
                <span className="mt-3 text-[13px] font-semibold text-slate" data-id="element-223" data-mp="2dgaj0nfc2amv">USD</span>
              </div>

              <div className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-224" data-mp="3tts91yylfnjq">
                <span className="rounded-full bg-amber px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-ink" data-id="element-225" data-mp="3ox1trdum4vzd">Save $70</span>
                <span className="rounded-full border border-cloud-dark px-2.5 py-1 text-[10px] font-semibold uppercase tracking-widest text-slate" data-id="element-226" data-mp="92h6qlpslrw">One-time payment</span>
                <span className="rounded-full border border-cloud-dark px-2.5 py-1 text-[10px] font-semibold uppercase tracking-widest text-slate" data-id="element-227" data-mp="3ng4rlqqze4rw">No app, no subscription</span>
              </div>

              <p className="mt-4 text-[13px] text-slate" data-id="element-228" data-mp="j1wmstxg71jg">That&apos;s under 50 cents a class.</p>

              <CtaButton href={CHECKOUT_URL} className="mt-4" data-id="element-229" data-mp="nywu1861aac5">
                Get Aerial Class Ready — only $27
              </CtaButton>

              <p className="mt-3 text-xs text-slate" data-id="element-230" data-mp="a6gw2lrzp2i3">Backed by the 7-day money-back guarantee</p>

              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-slate" data-id="element-231" data-mp="e823vspo2qlf">
                <li className="flex items-center gap-1.5" data-id="element-232" data-mp="11xwjuj5a8v9w">
                  <LockIcon className="h-4 w-4 text-teal-deep" aria-hidden="true" data-id="element-233" data-mp="16s0p8xywgv8v" />
                  Secure checkout
                </li>
                <li className="flex items-center gap-1.5" data-id="element-234" data-mp="3f55wdcx2eq2j">
                  <ZapIcon className="h-4 w-4 text-teal-deep" aria-hidden="true" data-id="element-235" data-mp="3a6uj0s7k9xfk" />
                  Access in 5 minutes
                </li>
                <li className="flex items-center gap-1.5" data-id="element-236" data-mp="317qzxo8e9i12">
                  <ShieldCheckIcon className="h-4 w-4 text-teal-deep" aria-hidden="true" data-id="element-237" data-mp="319btpbmvwwxv" />
                  7-day guarantee
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-slate" data-id="element-238" data-mp="3szozjqku1xlw">Price in USD. You&apos;ll be charged the equivalent in your local currency.</p>
      </div>
    </section>;
}